"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _Term = _interopRequireDefault(require("../../../../utilities/transcriptLib/Term"));

var _constants = require("../../../../utilities/transcriptLib/constants");

var _Turn = _interopRequireDefault(require("./Turn"));

var _connectToTranscript = _interopRequireDefault(require("../connectToTranscript"));

var _PropsToStateComponent = _interopRequireDefault(require("../../../../utilities/transcriptLib/PropsToStateComponent"));

var _compareRangeLists = _interopRequireDefault(require("../../../../utilities/transcriptLib/compareRangeLists"));

var _components = _interopRequireDefault(require("../../../../styles/components"));

var _connectToMedia = _interopRequireDefault(require("../../../Media/connectToMedia"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Content = /*#__PURE__*/function (_PropsToStateComponen) {
  _inheritsLoose(Content, _PropsToStateComponen);

  function Content() {
    return _PropsToStateComponen.apply(this, arguments) || this;
  }

  var _proto = Content.prototype;

  _proto.propsToState = function propsToState(pProps) {
    return (0, _lodash.pick)(_PropsToStateComponen.prototype.propsToState.call(this, pProps), "queries,speakers,speakerColors,transcriptsBySpeaker,transcriptTimeRanges,identifiedRangeBrackets".split(","));
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {
    if (!(0, _deepEqual["default"])(newProps.query, this.props.query)) return true;
    return !(0, _compareRangeLists["default"])(newState.transcriptTimeRanges, this.state.transcriptTimeRanges) || !(0, _compareRangeLists["default"])(newProps.transcriptTimeRanges, newState.transcriptTimeRanges) || !(0, _deepEqual["default"])(newState.identifiedRangeBrackets, this.state.identifiedRangeBrackets) || !(0, _compareRangeLists["default"])(newProps.identifiedRangeBrackets, newState.identifiedRangeBrackets);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        speakers = _this$props.speakers,
        speakerColors = _this$props.speakerColors,
        transcriptsBySpeaker = _this$props.transcriptsBySpeaker,
        isChatTextMedia = _this$props.isChatTextMedia,
        metadata = _this$props.metadata,
        fullTurns = _this$props.fullTurns;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].TranscriptBody, {
      isChatTextMedia: isChatTextMedia
    }, isChatTextMedia ? fullTurns.map(function (turn, index) {
      return /*#__PURE__*/_react["default"].createElement(_Turn["default"], {
        turnIndex: index,
        metadata: metadata,
        isChatTextMedia: isChatTextMedia,
        turn: turn,
        key: turn.text + "_" + index,
        speakers: speakers,
        speakerColors: speakerColors
      });
    }) : transcriptsBySpeaker.value.filter(function (turn) {
      return turn && turn instanceof _Term["default"] && turn.type === _constants.TYPE_ARRAY && turn.value.length;
    }).map(function (turn) {
      return /*#__PURE__*/_react["default"].createElement(_Turn["default"], {
        metadata: metadata,
        isChatTextMedia: isChatTextMedia,
        turn: turn,
        key: turn.id,
        speakers: speakers,
        speakerColors: speakerColors
      });
    }));
  };

  return Content;
}(_PropsToStateComponent["default"]);

var _default = (0, _connectToTranscript["default"])(Content);
/**
 propsToState(pProps) {
    return pick(super.propsToState(pProps),
      'speakers,speakerColors,transcriptsBySpeaker,transcriptTimeRanges,identifiedRangeBrackets'.split(','));
  }

 shouldComponentUpdate(newProps, newState) {
    return !compareRangeLists(newState.transcriptTimeRanges, this.state.transcriptTimeRanges)
      || !compareRangeLists(newProps.transcriptTimeRanges, newState.transcriptTimeRanges)
      || !equal(newState.identifiedRangeBrackets, this.state.identifiedRangeBrackets)
      || !compareRangeLists(newProps.identifiedRangeBrackets, newState.identifiedRangeBrackets);
  }
 */


exports["default"] = _default;